<template lang="">
  <div class="content-8">
    <div class="content-8__titlebar">
      <div class="content-8__titlebar__left">
        <div class="c8-titlename">
          <span class="c8-titlename__text">路珠分析</span>
        </div>

        <!-- 模式筛選 -->
        <div class="c8-menubox">
          <div class="menubar">
            <div class="menubar__itembox">
              <div
                v-for="(value, name) in tabItems()"
                :key="`${name}`"
                class="menubar__item"
                :class="{ active: mode === name }"
                @click="changeTab(name)"
              >
                <span class="menubar__item__text">{{ value }}</span>
                <div class="menubar__item__lightborder"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-8__titlebar__right">
        <DateFilterTab v-model="selectDate" @sendLeftHandle="doChange" />
      </div>
    </div>
    <TrendExplanation />
    <!-- 球位與路珠筛選 -->
    <div class="content-8__controlbar">
      <div v-if="mode === 'combine'">
        <CheckBoxButtons
          key="combineBall"
          v-model="selectBallFilter"
          :filter-data="getItemList('multiBall')"
          title="筛选球位"
        />
        <CheckBoxButtons
          key="combineType"
          v-model="selectTypeFilter"
          :filter-data="getItemList('multiType')"
          title="筛选路珠"
        />
      </div>

      <div v-if="mode === 'number'">
        <SingleSelectGroup
          key="numberBall"
          v-model="selectSingleBall"
          :filter-data="getItemList('singleBall')"
          title="筛选球位"
        />
        <CheckBoxButtons
          key="numberType"
          v-model="selectTypeFilter"
          :filter-data="getItemList('multiType')"
          title="筛选路珠"
        />
      </div>

      <div v-if="mode === 'type'">
        <CheckBoxButtons
          key="typeBall"
          v-model="selectBallFilter"
          :filter-data="getItemList('multiBall')"
          title="筛选球位"
        />
        <SingleSelectGroup
          key="type"
          v-model="selectSingleType"
          :filter-data="getItemList('singleType')"
          title="筛选路珠"
        />
      </div>
    </div>

    <!-- 資料顯示 -->
    <div v-if="rowData.length > 0 && !isLoading" class="content-8__content">
      <div
        v-for="(group, index) in filterData"
        :key="`${group.field}_${group.ruleType}_${index}`"
        class="luzhutable"
      >
        <div class="luzhutable__head">
          <div class="luzhutable__head__left">
            <div class="luzhutable-group">
              <span class="head-text">连续出现</span>
              <div class="inputbox">
                <input
                  :key="`${group.field}-count-${group.ruleType}-${mode}`"
                  :ref="`${group.field}-count-${group.ruleType}`"
                  class="inputbox__input"
                  type="number"
                  min="1"
                  value="0"
                >
              </div>
              <span class="head-text">次以上</span>
              <div class="selectbox">
                <select
                  :key="`${group.field}-type-${group.ruleType}-${mode}`"
                  :ref="`${group.field}-type-${group.ruleType}`"
                  class="selectbox__select"
                >
                  <template v-for="(total, totalIndex) in luZhuSortMapping">
                    <option
                      v-if="group.totals[total.key] || isHeZero(total.key, group.ruleType, group.field)"
                      :key="`sort-${totalIndex}`"
                      :value="total.key"
                    >
                      <template> {{ total.key | ballType }} </template>
                    </option>
                  </template>
                </select>
              </div>
              <a
                class="button-primary active"
                @click.prevent="handleSortLight(group)"
              >
                <span class="button-primary__text">确定</span>
              </a>
            </div>
            <div class="luzhutable-group">
              <span class="head-text">出现的次数:</span>
              <span
                :ref="`${group.field}-${group.ruleType}-value`"
                class="head-text"
              >{{ getCount(`${group.field}-${group.ruleType}`) }}</span>
            </div>
          </div>
          <div class="luzhutable__head__right">
            <div class="luzhutable-group">
              <span class="head-text">今日累计:</span>
              <template v-for="(mappingItem, sortIndex) in luZhuSortMapping">
                <span
                  v-if="group.totals[mappingItem.key]"
                  :key="`sort-${sortIndex}`"
                >
                  <template>{{ mappingItem.key | ballType }}({{ group.totals[mappingItem.key] }}) </template>
                </span>
                <span
                  v-else-if="isHeZero(mappingItem.key, group.ruleType, group.field)"
                  :key="`sort-${sortIndex}`"
                >
                  和(0)
                </span>
              </template>
            </div>
            <div class="luzhutable-group">
              <span class="head-text red">{{ group.field | ballRank }}</span>
              <span class="head-text red">{{ isMantissa(group) }}</span>
              <span class="head-text red">最新↓</span>
            </div>
          </div>
        </div>
        <div class="luzhutable-scroll">
          <div
            :ref="`${group.field}-${group.ruleType}`"
            class="luzhutable__content"
          >
            <div
              v-for="(point, pointIndex) in group.roadBeads"
              :key="`point-${pointIndex}`"
              class="luzhutable__content__item"
              :class="handleHighlight(group, point)"
            >
              <div class="textbox">
                <div
                  v-for="(pointItem, pointItemIndex) in point"
                  :key="`point-item-${pointItemIndex}`"
                  class="textbox__item"
                  :class="textColor(pointItem)"
                >
                  <span class="textbox__item__text">{{
                    pointItem | ballType
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <NoData v-if="rowData.length === 0 && !isLoading" />
    <Loading v-if="isLoading" />
  </div>
</template>

<script>
import TrendExplanation from '@/components/web/pages/trend/TrendExplanation/index'
import CheckBoxButtons from '@/components/web/common/CheckBoxButtons'
import SingleSelectGroup from '@/components/web/common/SingleSelectGroup'
import { getRoadBallCount_mobile } from '@/api/mobile/roadball'
import DateFilterTab from '@/components/web/pages/trend/DateFilterTab'

import { filterMapping } from '@/utils/luJhu/filterMapping'

import { commonMethodMixin } from '@/components/web/common/mixins/luJhuFenSi.js'

import Loading from '@/components/web/common/Loading'
import NoData from '@/components/web/common/NoData'

const filterBall = [
  { name: 'hm1', val: 'hm1' },
  { name: 'all', val: 'all' },
  { name: 'allmantissa', val: 'allmantissa' },
  { name: 'group1_8', val: 'hm1' },
  { name: 'hm2', val: 'hm2' },
  { name: 'group2_7', val: 'hm2' },
  { name: 'hm3', val: 'hm3' },
  { name: 'group3_6', val: 'hm3' },
  { name: 'hm4', val: 'hm4' },
  { name: 'group4_5', val: 'hm4' },
  { name: 'hm5', val: 'hm5' },
  { name: 'hm6', val: 'hm6' },
  { name: 'hm7', val: 'hm7' },
  { name: 'hm8', val: 'hm8' },
  { name: 'hm9', val: 'hm9' },
  { name: 'hm10', val: 'hm10' }
]

const filterType = [
  // 单双
  { name: 'hmDanShuang', val: 'hmDanShuang' },
  // 大小
  { name: 'hmDaXiao', val: 'hmDaXiao' },
  // 尾數大小
  { name: 'hmWeiShuDaXiao', val: 'hmWeiShuDaXiao' },
  // 合數单双
  { name: 'hmHeDanShuang', val: 'hmHeDanShuang' },
  // 龍虎
  { name: 'zuLongHu', val: 'zuLongHu' },
  // 中發白
  { name: 'zhongFaBai', val: 'zhongFaBai' },
  // 方位
  { name: 'fangWei', val: 'fangWei' },
  // 總和大小
  { name: 'zongHeDaXiao', val: 'zongHeDaXiao' },
  // 總和单双
  { name: 'zongHeDanShuang', val: 'zongHeDanShuang' }
]

export default {
  name: 'KL10',
  components: {
    CheckBoxButtons,
    SingleSelectGroup,
    DateFilterTab,
    TrendExplanation,
    Loading,
    NoData
  },
  filters: {
    // 第幾球翻譯
    ballRank(value) {
      switch (value) {
        case 'hm1':
        case 'group1_8':
          return '第一球'
        case 'hm2':
        case 'group2_7':
          return '第二球'
        case 'hm3':
        case 'group3_6':
          return '第三球'
        case 'hm4':
        case 'group4_5':
          return '第四球'
        case 'hm5':
          return '第五球'
        case 'hm6':
          return '第六球'
        case 'hm7':
          return '第七球'
        case 'hm8':
          return '第八球'
        case 'all':
        case 'allmantissa':
          return '总和'
        default:
          console.error('错误球种排名', value)
          return value
      }
    },
    // 球種類型翻譯
    ballType(value) {
      switch (value) {
        case 'danshuang_dan':
          return '单'
        case 'danshuang_shuang':
          return '双'
        case 'daxiao_da':
          return '大'
        case 'daxiao_xiao':
          return '小'
        case 'longHu_long':
          return '龙'
        case 'longHu_hu':
          return '虎'
        case 'daxiao_he':
        case 'longHu_he':
        case 'danshuang_he':
          return '和'
        case 'maJiang_bai':
          return '白'
        case 'maJiang_fa':
          return '发'
        case 'maJiang_jhong':
          return '中'
        case 'fangSiang_dong':
          return '东'
        case 'fangSiang_nan':
          return '南'
        case 'fangSiang_si':
          return '西'
        case 'fangSiang_bei':
          return '北'
        default:
          console.error('错误球种类别', value)
          return value
      }
    }
  },
  mixins: [commonMethodMixin],
  props: {
    lotteryType: {
      type: String,
      default: '',
      required: true
    }
  },
  data: function() {
    return {
      loading: true,
      selectBallFilter: [],
      selectTypeFilter: [],
      selectSingleBall: '',
      selectSingleType: '',
      rowData: [],
      mode: 'combine',
      hightlightObj: {},
      selectDate: '',
      luZhuSortMapping: [
        { key: 'daxiao_da', label: '大' },
        { key: 'daxiao_xiao', label: '小' },
        { key: 'danshuang_dan', label: '单' },
        { key: 'danshuang_shuang', label: '双' },
        { key: 'longHu_long', label: '龙' },
        { key: 'longHu_hu', label: '虎' },
        { key: 'maJiang_jhong', label: '中' },
        { key: 'maJiang_fa', label: '发' },
        { key: 'maJiang_bai', label: '白' },
        { key: 'fangSiang_dong', label: '东' },
        { key: 'fangSiang_nan', label: '南' },
        { key: 'fangSiang_si', label: '西' },
        { key: 'fangSiang_bei', label: '北' },

        { key: 'danshuang_he', label: '和' },
        { key: 'daxiao_he', label: '和' }
      ]
    }
  },
  computed: {
    filterData() {
      return this.rowData.filter((item, index) => {
        const ball = filterBall.find((ele) => ele.name === item.field)
        const type = filterType.find((ele) => ele.name === item.ruleType)

        // 綜合模式
        if (this.mode === 'combine') {
          // 因為總和單雙和總和大小也必須算在出現在單雙和大小底下，所以這邊做處理
          if (
            item.ruleType === 'zongHeDanShuang' &&
            this.selectBallFilter.includes('all') &&
            this.selectTypeFilter.includes('hmDanShuang') &&
            item.field === 'all'
          ) {
            return true
          }

          if (
            item.ruleType === 'zongHeDaXiao' &&
            this.selectBallFilter.includes('all') &&
            this.selectTypeFilter.includes('hmDaXiao') &&
            item.field === 'all'
          ) {
            return true
          }

          // 總和尾數大小顯示
          if (
            item.ruleType === 'zongHeDaXiao' &&
            this.selectBallFilter.includes('all') &&
            this.selectTypeFilter.includes('hmWeiShuDaXiao') &&
            item.field === 'allmantissa'
          ) {
            return true
          }

          return (
            this.selectBallFilter.includes(ball && ball.val) &&
            this.selectTypeFilter.includes(type && type.val)
          )
        }

        // 单面模式
        if (this.mode === 'number') {
          // 因為總和單雙和總和大小也必須算在出現在單雙和大小底下，所以這邊做處理
          if (
            item.ruleType === 'zongHeDanShuang' &&
            this.selectSingleBall === 'all' &&
            this.selectTypeFilter.includes('hmDanShuang') &&
            item.field === 'all'
          ) {
            return true
          }

          if (
            item.ruleType === 'zongHeDaXiao' &&
            this.selectSingleBall === 'all' &&
            this.selectTypeFilter.includes('hmDaXiao') &&
            item.field === 'all'
          ) {
            return true
          }

          // 總和尾數大小顯示
          if (
            item.ruleType === 'zongHeDaXiao' &&
            this.selectSingleBall === 'all' &&
            this.selectTypeFilter.includes('hmWeiShuDaXiao') &&
            item.field === 'allmantissa'
          ) {
            return true
          }

          return ball
            ? this.selectSingleBall === ball.val &&
                this.selectTypeFilter.includes(type && type.val)
            : ''
        }

        // 兩面模式
        if (this.mode === 'type') {
          // 因為總和單雙和總和大小也必須算在出現在單雙和大小底下，所以這邊做處理
          if (
            item.ruleType === 'zongHeDanShuang' &&
            this.selectBallFilter.includes('all') &&
            this.selectSingleType === 'hmDanShuang' &&
            item.field === 'all'
          ) {
            return true
          }

          if (
            item.ruleType === 'zongHeDaXiao' &&
            this.selectBallFilter.includes('all') &&
            this.selectSingleType === 'hmDaXiao' &&
            item.field === 'all'
          ) {
            return true
          }

          // 總和尾數大小顯示
          if (
            item.ruleType === 'zongHeDaXiao' &&
            this.selectBallFilter.includes('all') &&
            this.selectSingleType === 'hmWeiShuDaXiao' &&
            item.field === 'allmantissa'
          ) {
            return true
          }

          return (
            this.selectBallFilter.includes(ball && ball.val) &&
            (type ? this.selectSingleType === type.name : '')
          )
        }
      })
    }
  },
  watch: {
    selectDate(newValue) {
      this.getLuJhuData(newValue)
    },
    selectBallFilter() {
      this.initHighLightObj(this.rowData)
    },
    selectTypeFilter() {
      this.initHighLightObj(this.rowData)
    },
    selectSingleBall() {
      this.initHighLightObj(this.rowData)
    },
    selectSingleType() {
      this.initHighLightObj(this.rowData)
    }
  },
  created() {
    this.init()
    this.setDefaultSelect(this.lotteryType)
  },
  methods: {
    init() {
      this.getLuJhuData('30')
    },
    async getLuJhuData(query) {
      this.isLoading = true
      const code = this.$route.params.lottery_code
      const rules =
        'hmDanShuang,hmDaXiao,zuLongHu,zongHeDanShuang,zongHeDaXiao,hmWeiShuDaXiao,hmHeDanShuang,zhongFaBai,fangWei'
      const form = {}

      if (/^\d{2}$/.test(query)) {
        form.count = query
      } else {
        form.date = query
      }

      const [data, error] = await getRoadBallCount_mobile({
        code,
        rules,
        ...form
      })
      if (error) {
        console.log(error)
        return
      }

      const sortBy = [
        'hm1',
        'group1_8',
        'hm2',
        'group2_7',
        'hm3',
        'group3_6',
        'hm4',
        'group4_5',
        'hm5',
        'hm6',
        'hm7',
        'hm8',
        'all',
        'allmantissa'
      ]

      let showData = []

      // 不需要顯示總和尾數单双，所以這邊移除，還有把龍虎的排序調整
      showData = data
        .filter((data) => {
          return (
            data.field !== 'allmantissa' || data.ruleType !== 'zongHeDanShuang'
          )
        })
        .map((item) => {
          if (item.ruleType === 'zuLongHu') {
            item.field = `hm${item.field[5]}`
          }
          return item
        })

      // 依照球排名排序
      showData.sort(function(a, b) {
        return sortBy.indexOf(a.field) - sortBy.indexOf(b.field)
      })

      this.initHighLightObj(data)
      this.isLoading = false
      this.rowData = showData
    },
    getItemList(name) {
      const type = this.lotteryType
      switch (name) {
        // 複選球位
        case 'multiBall':
          return filterMapping[type].ballText
        // 複選路珠
        case 'multiType':
          return filterMapping[type].typeText
        // 单選球位
        case 'singleBall':
          return filterMapping[type].ballText
        // 单選路珠
        case 'singleType':
          return filterMapping[type].typeText
        default:
          return []
      }
    },
    getBallList() {
      return [
        { name: '冠军', val: 'hm1' },
        { name: '亚军', val: 'hm2' },
        { name: '第三名', val: 'hm3' },
        { name: '第四名', val: 'hm4' },
        { name: '第五名', val: 'hm5' },
        { name: '第六名', val: 'hm6' },
        { name: '第七名', val: 'hm7' },
        { name: '第八名', val: 'hm8' },
        { name: '第九名', val: 'hm9' },
        { name: '第十名', val: 'hm10' }
      ]
    },
    isMantissa(item) {
      if (item.field.includes('mantissa')) {
        return '尾大尾小'
      } else {
        switch (item.ruleType) {
          case 'hmDanShuang':
          case 'guanYaHeDanShuang':
          case 'zongHeDanShuang':
            return '单双'
          case 'hmDaXiao':
          case 'zongHeDaXiao':
            return '大小'
          case 'zuLongHu':
          case 'longHu':
            return '龙虎'
          case 'daxiao_he':
            return '和'
          case 'guanYaHeDaXiao':
            return '大小'
          case 'fangWei':
            return '东南西北'
          case 'zhongFaBai':
            return '中发白'
          case 'hmHeDanShuang':
            return '合数单双'
          case 'hmWeiShuDaXiao':
            return '尾大尾小'
          default:
            console.error('错误分组类别名称', item.ruleType)
            return item.ruleType
        }
      }
    },
    // 判斷是否要顯示 和(0)
    isHeZero(openType, ruleType, field) {
      // 大小和
      if (openType === 'daxiao_he' && ruleType === 'zongHeDaXiao' && field === 'all') {
        return true
      }

      return false
    }
  }
}
</script>
